import React from "react";
import CardContent from "../../../cards/common/CardContent";
import CardFilterPills from "../../../cards/common/CardFilterPills";
import CardSubheader from "../../../cards/common/CardSubheader";
import TocHeader from "./TocHeader";
import CardFooter from "../../../cards/common/CardFooter";
import TocContent from "./TocContent";

const VerbatimCard = ({
  item,
  book,
  userLikes,
  playlists,
  feedbacks,
  showFeedbackModal,
  showShareModal,
  isAuthenticated,
  canProceed,
  propGroup,
  feedbackSentContentKeys,
  lookup
}) => {
  return (
    <div
      id={item.id}
      className={"flex border border-gray-500 rounded-sm mb-5 bg-white"}
    >
      <div className="w-full">
        <TocHeader book={book} />
        <div className="px-5 mt-4">
          <CardSubheader subheader={item.title} isExpandable={false} />
          <TocContent post={item} book={book}/>
          <CardFilterPills
            post={item}
            lookup={lookup}
            canProceed={canProceed}
          />
        </div>
        <CardFooter
          post={item}
          showShareModal={showShareModal}
          showFeedbackModal={showFeedbackModal}
          canProceed={canProceed}
          isAuthenticated={isAuthenticated}
          feedbackSentContentKeys={feedbackSentContentKeys}
          playlists={playlists}
          propGroup={propGroup}
          feedbacks={feedbacks}
          userLikes={userLikes}
        />
      </div>
    </div>
  );
};

export default VerbatimCard;
